import AiEmailEnvelopIcon from '../../../../../../assets/images/ai-seq-modal/aiEmailEnvelope.svg';
import BriefCaseIcon from '../../../../../../assets/images/ai-seq-modal/briefCase.svg';
import StarIcon from '../../../../../../assets/images/ai-seq-modal/stars.svg';
import TargetIcon from '../../../../../../assets/images/ai-seq-modal/target.svg';
import WorldIcon from '../../../../../../assets/images/ai-seq-modal/world.svg';
import { AiSequenceGeneratorSteps } from '../../enums';

/**
 * @description Step Texts Map => Contains the text for each step
 * @returns {string[]} Step Texts
 */
const stepTextsMap = {
  [AiSequenceGeneratorSteps.COMPANY_INFO]: [
    'Analysing business details',
    'Finding services and products',
    'Detecting company name and industry',
    'Collecting customer feedback',
    'Reviewing achievements and stats',
  ],
  [AiSequenceGeneratorSteps.COMPANY_DATA_CONFIRM]: [
    'Loading campaign options',
    'Matching goals with business type',
    'Reviewing outreach strategies',
    'Checking common use cases',
    'Setting up goal direction',
  ],
  [AiSequenceGeneratorSteps.GOAL_SELECTION]: [
    'Reviewing business for Services',
    'Finding key selling points',
    'Creating goal-based questions',
    'Analyzing industry trends',
    'Customizing next steps',
  ],
  [AiSequenceGeneratorSteps.GOAL_REFINEMENT]: [
    'Listing top Services/Products',
    'Matching with final goal',
    'Reviewing benefits',
    'Suggesting main services',
    'Preparing options',
  ],
  [AiSequenceGeneratorSteps.SERVICE_SELECTION]: [
    'Finding common customer roles',
    'Reviewing audience types',
    'Matching pain points',
    'Suggesting best-fit profiles',
    'Building customer match list',
  ],
  [AiSequenceGeneratorSteps.ICP_GENERATION]: [
    'Planning Sequence steps flow',
    'Reviewing outreach depth',
    'Loading best sequence format',
    'Matching length to goal',
    'Setting follow-up structure',
  ],
  [AiSequenceGeneratorSteps.SEQUENCE_LENGTH]: [
    'Writing custom emails',
    'Adding spintext variations',
    'Personalizing key parts',
    'Sequencing follow-up steps',
    'Finalizing campaign content',
  ],
};

/**
 * @description Icons for the loading animation card
 * @returns {React.ReactNode[]} Icons
 */
const icons = [
  StarIcon,
  WorldIcon,
  BriefCaseIcon,
  TargetIcon,
  AiEmailEnvelopIcon,
];

/**
 * @description Get the step content
 * @param {AiSequenceGeneratorSteps} step - Step
 * @returns {React.ReactNode[]} Step Content
 */
export const getStepContent = (step: AiSequenceGeneratorSteps) => {
  const texts = stepTextsMap[step] || [];

  return icons.map((icon, index) => ({
    icon,
    text: texts[index] || '',
  }));
};
